
import { Card, CardContent, CardDescription, CardTitle } from "../ui/card";
import { WarpBackground } from "../ui/warp-background";

export function WrapBg() {
    return (
        <WarpBackground className="border-none bg-[#ffffff09] backdrop-blur-md">
            <Card className="w-80 rounded-[1px] bg-background border-[1px] border-[#b2b2b280]">
                <CardContent className="flex flex-col gap-2 p-4">
                    <CardTitle className="p-1">لورم ایپسوم متن ساختگی!</CardTitle>
                    <CardDescription className="p-1">
                        تلاش و سخت‌کوشی تو نتیجه داده! خیلی خوشحالیم که قدم بعدی رو در مسیر شغلی‌ات برمی‌داری. به همین روال فوق‌العاده ادامه بده!
                    </CardDescription>
                </CardContent>
            </Card>
        </WarpBackground>
    );
}
